import { useState } from 'react';

export interface MapFilters {
  showPermanentAddresses: boolean;
  showCurrentTempLocations: boolean;
  showUpcomingTempLocations: boolean;
  showMyTempLocations: boolean;
  selectedFriendId: number | null; // Filter to show only a specific friend's markers
  selectedListId: number | null; // Filter to show only markers from a specific list
}

/**
 * Hook to manage map display filters
 */
export const useMapFilters = () => {
  const [mapFilters, setMapFilters] = useState<MapFilters>({
    showPermanentAddresses: true,
    showCurrentTempLocations: true,
    showUpcomingTempLocations: true,
    showMyTempLocations: true,
    selectedFriendId: null,
    selectedListId: null,
  });

  const [showFiltersPanel, setShowFiltersPanel] = useState(false);
  const [isFiltersExpanded, setIsFiltersExpanded] = useState(true);

  return {
    mapFilters,
    setMapFilters,
    showFiltersPanel,
    setShowFiltersPanel,
    isFiltersExpanded,
    setIsFiltersExpanded,
  };
};
